import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { ThreeDots } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import "../../Styles/style.css";
import { getApi } from "../../utils/api";
import { API_GET_PROJECTS_BY_EMPLOYEE_ID } from "../../config/Endpoints";
import { displayFormatDate } from "../../utils/helpers";
import { MdKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import { projectTypeOptions } from "../../options/projectTypesOptions";
import DisplayMembersTableTabs from "../../components/ProjectManagement/DisplayMembersTableTabs";
import ProjectEnrollmentRequestModal from "../../components/ProjectManagement/ProjectEnrollmentRequestModal";
import { FiUserPlus } from "react-icons/fi";
function MyProjects({ title, description }) {
  const [projectList, setProjectList] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const employeeId = userData?.id;
  const getProjectTypeLabel = (value) => {
    const option = projectTypeOptions.find((opt) => opt.value === value);
    return option ? option.label : value;
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(projectList);
  const [isLoading, setisLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [openProjectId, setOpenProjectId] = useState(null);
  const [showEnrollmentRequest, setShowEnrollmentRequest] = useState(false);
  const toggleProject = (id) => {
    setOpenProjectId(openProjectId === id ? null : id);
  };
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setisLoading(true);
        const response = await getApi(
          `${API_GET_PROJECTS_BY_EMPLOYEE_ID}/${employeeId}`,
          accessToken
        );

        const employeeProjects = response.data?.data?.projects || [];

        const detailedProjects = employeeProjects.map((p) => ({
          id: p.projectId,
          projectName: p.projectName || "Untitled Project",
          projectType: p.projectType,
          startDate: p.startDate,
          endDate: p.endDate,
          sowStartDate: p.sowStartDate,
          sowEndDate: p.sowEndDate,
          commercialSummary: p.commercialSummary || "No description available",
          dlId: p.dlId,
          dlName: p.dlName,
          projectManagerName: p.projectManagerName,
          principalSponsorName: p.principalSponsorName,
          projectManagerId: p.projectManagerId,
          programManagerId: p.programManagerId,
          programManagerName: p.programManagerName,
          principalSponsorId: p.principalSponsorId,
          leadBusinessAnalyst: p.leadBusinessAnalyst,
          leadBusinessAnalystName: p.leadBusinessAnalystName,
          workstreams: Array.isArray(p.workstreams) ? p.workstreams : [],
          status: p.status,
          members:
            p.members?.map((m) => ({
              id: m.id,
              name: `${m.fullName}`.trim(),
              email: m.email,
              designation: m.designation,
              expertise: m.expertise,
              joinDate: m.createdDate,
              endDate: m.endDate,
              status: m.status,
            })) || [],

          shadowMembers:
            p.shadowMembers?.map((s) => ({
              id: s.id,
              shadowEmployeeName: s.shadowEmployeeName,
              workingEmployeeName: s.workingEmployeeName,
              designation: s.designation,
              expertise: s.expertise,
              joiningDate: s.joiningDate,
              endDate: s.endDate,
              status: s.status,
            })) || [],
        }));

        setProjectList(detailedProjects);
        setFilteredItems(detailedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setisLoading(false);
      }
    };

    if (employeeId) fetchProjects();
  }, [employeeId, accessToken]);

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    const filtered = projectList.filter((item) =>
      item.projectName.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredItems(filtered);
  };

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Projects :{" "}
          <span>{searchTerm ? filteredItems.length : projectList.length}</span>
        </div>
      </div>

      {/* <div className="d-flex justify-content-end mb-3">
        <button
          type="button"
          className="btn theme-button d-inline-flex align-items-center gap-2"
          onClick={() => setShowEnrollmentRequest(true)}
        >
          <FiUserPlus aria-hidden />
          Request to Join a Project
        </button>
      </div> */}

      <div className="filters">
        <div className="search m-0">
          <input
            type="text"
            name="search"
            placeholder="Search By Project Name"
            value={searchTerm}
            onChange={handleSearch}
            className="rounded-sm"
          />
          <img src="/assets/images/search-ico.svg" width="14" alt="Search" />
        </div>

        <div className="actions"></div>
      </div>

      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      <div className="accordion" id="accordionProjects">
        {!isLoading && filteredItems.length === 0 ? (
          <p className="fs-4 m-5 text-secondary text-center">
            No Projects Assigned
          </p>
        ) : (
          filteredItems.map((project) => {
            return (
              <div
                className="accordion-item project-accordion-item rounded-lg-top"
                key={project.id}
              >
                <h2 className="accordion-header " id={`heading-${project.id}`}>
                  <button
                    className={` accordion-button ${openProjectId === project.id ? "" : "collapsed"
                      }`}
                    type="button"
                    onClick={() => toggleProject(project.id)}
                  >
                    <span>{project.projectName}</span>

                    <span
                      className={`project-status-badge ${project.status === 1
                          ? "badge-complete"
                          : project.status === 2
                            ? "badge-onhold"
                            : "badge-active"
                        }`}
                    >
                      {project.status === 1
                        ? "Completed"
                        : project.status === 2
                          ? "On Hold"
                          : "Active"}
                    </span>

                    {openProjectId === project.id ? (
                      <MdOutlineKeyboardArrowUp className="dropdown-icon" />
                    ) : (
                      <MdKeyboardArrowDown className="dropdown-icon" />
                    )}
                  </button>
                </h2>

                <div
                  id={`collapse-${project.id}`}
                  className={`accordion-collapse collapse ${openProjectId === project.id ? "show" : ""
                    }`}
                  aria-labelledby={`heading-${project.id}`}
                  data-bs-parent="#accordionProjects"
                >
                  <div className="accordion-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row mb-2 g-0 d-flex project-details-section">
                          <div className="col-md-6 px-4 mt-2  d-flex flex-column project-details">
                            <div className="row p-2 mt-2 align-items-center  ">
                              <label className="col-md-5  text-black-50 mb-2 ">
                                Project Name
                              </label>
                              <div
                                className="col-md-7 px-4 py-2 rounded-2 project-details-field"
                                style={{
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "normal",
                                }}
                              >
                                {project.projectName}
                              </div>
                            </div>
                            <div className="row p-2 align-items-center">
                              <label className="col-md-5  text-black-50 mb-2">
                                Project Type
                              </label>
                              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                {getProjectTypeLabel(project?.projectType)}
                              </div>
                            </div>
                            <div className="row p-2 align-items-center">
                              <label className="col-md-5  text-black-50 mb-2">
                                Delivery Lead
                              </label>
                              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                {project.dlName ? project.dlName : "N/A"}
                              </div>
                            </div>
                            <div className="row p-2  align-items-center">
                              <label className="col-md-5  text-black-50 mb-2">
                                Project Manager
                              </label>
                              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                {project.projectManagerName || "N/A"}
                              </div>
                            </div>

                            <div className="row p-2  align-items-center">
                              <label className="col-md-5  text-black-50 mb-2">
                                Program Manager
                              </label>
                              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                                {project.programManagerName || "N/A"}
                              </div>
                            </div>

                            <div className="row p-2 align-items-center">
                              <label className="col-md-5  text-black-50 mb-2">
                                Principal Sponsor
                              </label>
                              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field">
                                {project.principalSponsorName || "N/A"}
                              </div>
                            </div>

                            {project.leadBusinessAnalystName && (
                              <div className="row p-2 align-items-center">
                                <label className="col-md-5 text-black-50 mb-2">
                                  Lead Business Analyst
                                </label>
                                <div className="col-md-7 px-4 py-2 rounded-2 project-details-field">
                                  {project.leadBusinessAnalystName}
                                </div>
                              </div>
                            )}

                            <div className="row p-2 align-items-center">
                              <label className="col-md-5 text-black-50 mb-2">
                                SOW
                              </label>
                              <div className="col-md-7 d-flex gap-2 p-0">
                                <div className="position-relative project-date-box">
                                  <span className="m-0 dateBadgeStyle">
                                    Start Date
                                  </span>
                                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                    {project.sowStartDate
                                      ? displayFormatDate(project.sowStartDate)
                                      : "Ongoing"}
                                  </div>
                                </div>
                                <div className="position-relative project-date-box">
                                  <span className="m-0 dateBadgeStyle">
                                    End Date
                                  </span>
                                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                    {project.sowEndDate
                                      ? displayFormatDate(project.sowEndDate)
                                      : "Ongoing"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row p-2 align-items-center">
                              <label className="col-md-5 text-black-50 mb-2">
                                Actual
                              </label>
                              <div className="col-md-7 d-flex gap-2 p-0">
                                <div className="position-relative project-date-box">
                                  <span className="m-0 dateBadgeStyle">
                                    Start Date
                                  </span>
                                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                    {project.startDate
                                      ? displayFormatDate(project.startDate)
                                      : "Ongoing"}
                                  </div>
                                </div>
                                <div className="position-relative project-date-box">
                                  <span className="m-0 dateBadgeStyle">
                                    End Date
                                  </span>
                                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                                    {project.endDate
                                      ? displayFormatDate(project.endDate)
                                      : "Ongoing"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-6 px-4 mt-2 d-flex flex-column project-details"
                            style={{ height: "100%" }}
                          >
                            <label className=" px-2 mb-2 py-2 text-black-50">
                              Project Description
                            </label>
                            <div className="summary-content rounded-2 p-4 project-details-field-description">
                              {project.commercialSummary}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <DisplayMembersTableTabs project={project} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      <ProjectEnrollmentRequestModal
        open={showEnrollmentRequest}
        onClose={() => setShowEnrollmentRequest(false)}
      />

      <Footer />
    </div>
  );
}

export default MyProjects;
